/**
 * A simple navigation service to allow navigation from non-React contexts
 * like service workers and utility services
 */
class NavigationService {
  private static instance: NavigationService
  private navigateCallback: ((path: string) => void) | null = null

  /**
   * Get the singleton instance
   */
  public static getInstance(): NavigationService {
    if (!NavigationService.instance) {
      NavigationService.instance = new NavigationService()
    }
    return NavigationService.instance
  }

  /**
   * Set the navigate function from a React component
   * @param navigateFunction The navigate function from React Router
   */
  public setNavigate(navigateFunction: (path: string) => void): void {
    this.navigateCallback = navigateFunction
  }

  /**
   * Navigate to a specific path
   * @param path The path to navigate to
   * @returns true if navigation was handled, false if no navigate function is set
   */
  public navigate(path: string): boolean {
    if (this.navigateCallback) {
      try {
        this.navigateCallback(path)
        return true
      } catch (error) {
        console.error('NavigationService: Error in navigate callback:', error)
        return false
      }
    }

    // Fallback to direct navigation if no callback is set
    console.warn('NavigationService: No navigate function set, falling back to direct navigation')
    try {
      window.location.href = path
      return true
    } catch (error) {
      console.error('NavigationService: Error in direct navigation:', error)
      return false
    }
  }
}

export default NavigationService
